import 'bootstrap';
import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/es';
import numeral from 'numeral';
import numeralLocale from 'numeral/locales/es';

import PovertyMultiDimensionVisualization from './Components/Visualizations/PovertyMultiDimensionVisualization';
import PovertyMultiVisualization from './Components/Visualizations/PovertyMultiVisualization';
import PovertyIncomeVisualization from './Components/Visualizations/PovertyIncomeVisualization';
import MoneyIncomeVisualization from './Components/Visualizations/MoneyIncomeVisualization';
import MedicalAttentionsVisualization from './Components/Visualizations/MedicalAttentionsVisualization';
import HealthAffiliationVisualization from './Components/Visualizations/HealthAffiliationVisualization';
import LaborParticipationVisualization from './Components/Visualizations/LaborParticipationVisualization';
import LaborIncomeVisualization from './Components/Visualizations/LaborIncomeVisualization';
import QualityHousingVisualization from './Components/Visualizations/QualityHousingVisualization';


numeral.locale('es', numeralLocale);
numeral.register('format', 'custom-percentage', {
    regexps: {
        format: /(percentage)/,
        unformat: /(percentage)/
    },
    format: function(value, format, roundingFunction) {
        var space = numeral._.includes(format, ' %') ? ' ' : '',
            output;

        //value = value * 100;

        // check for space before %
        format = format.replace(/\s?\%/, '');

        output = numeral._.numberToFormat(value, format, roundingFunction);

        if (numeral._.includes(output, ')')) {
            output = output.split('');

            output.splice(-1, 0, space + '%');

            output = output.join('');
        } else {
            output = output + space + '%';
        }

        return output;
    },
    unformat: function(string) {
        return numeral._.stringToNumber(string) /* * 0.01*/;
    }
});
Vue.use(ElementUI, { locale });

new Vue({
    el: '#app',
    components:{
        PovertyMultiDimensionVisualization,
        PovertyMultiVisualization,
        PovertyIncomeVisualization,
        MoneyIncomeVisualization,
        MedicalAttentionsVisualization,
        HealthAffiliationVisualization,
        LaborParticipationVisualization,
        LaborIncomeVisualization,
        QualityHousingVisualization
    }
});


// WEBPACK FOOTER //
// ./src/js/app.js